import { createReducer } from "@reduxjs/toolkit"
import { initialState } from "./init"
import {
    addPage,
    forcedModifyState,
    setFilteredData,
    setFilteredDataFetchApi,
    setFilters,
    setLoadingState,
    setModule,
    setModuleData,
    resetTemplateData,
} from "./actions"

function getProperty(obj, key) {
    // Split the key into its parts
    const keys = key.split(".")

    // Traverse the object based on the parts of the key
    for (const k of keys) {
        if (obj && typeof obj === "object" && obj.hasOwnProperty(k)) {
            obj = obj[k]
        } else {
            // Property not found, return undefined
            return undefined
        }
    }

    // Return the final property value
    return obj
}

function setProperty(obj, key, value) {
    // Split the key into its parts
    const keys = key.split(".")

    // Traverse the object based on the parts of the key
    for (let i = 0; i < keys.length - 1; i++) {
        const k = keys[i]
        if (obj && typeof obj === "object" && obj.hasOwnProperty(k)) {
            obj = obj[k]
        } else {
            // If any part of the key doesn't exist, create it as an empty object
            obj[k] = {}
            obj = obj[k]
        }
    }

    // Set the final property value
    const lastKey = keys[keys.length - 1]
    obj[lastKey] = value
}

// ✅ Helper: ensures module + datatable exist
function ensureModuleDatatable(state, moduleName) {
    if (!state[moduleName]) {
        state[moduleName] = {}
    }
    if (!state[moduleName].datatable) {
        state[moduleName].datatable = {}
    }
    return state[moduleName].datatable
}

const TemplateDataReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setModule, (state, action) => {
            state.module = action.payload
        })
        .addCase(resetTemplateData, () => {
            // Clear cached module datatable data when switching websites/apps.
            // Return a fresh copy so we don't reuse the same object reference.
            return JSON.parse(JSON.stringify(initialState))
        })
        .addCase(setModuleData, (state, action) => {
            const { module, data, meta, page_info } = action.payload

            const datatable = ensureModuleDatatable(state, module)

            datatable.data = data
            datatable.meta = meta
            state[module].page_info = page_info

            return state
        })
        .addCase(setLoadingState, (state, action) => {
            state.loading = action.payload
        })
        .addCase(setFilters, (state, action) => {
            const datatable = ensureModuleDatatable(state, state.module)
            datatable.filters = action.payload
            return state
        })
        .addCase(setFilteredData, (state, action) => {
            const datatable = ensureModuleDatatable(state, state.module)
            datatable.filteredData = action.payload
            return state
        })
        .addCase(setFilteredDataFetchApi, (state, action) => {
            const { data, page_name } = action.payload
            const datatable = ensureModuleDatatable(state, page_name)
            datatable.filteredData = data
            return state
        })
        .addCase(addPage, (state, action) => {
            state[action.payload.key] = action.payload.data
            return state
        })
        .addCase(forcedModifyState, (state, action) => {
            const {
                payload: { module, data },
            } = action

            setProperty(state, module, data)
            return state
        })
        .addDefaultCase((state, action) => state)
})

export default TemplateDataReducer
